import gql from 'graphql-tag';

export const getRecentActivityQuery = gql(`
  query getRecentActivity(
    $search: UserContentInteractionSearch
    $pagination: PaginationInput
  ) {
    me {
      contentInteractions(pagination: $pagination, search: $search) {
        items {
          _id
          _created
          _updated
          status
          startDate
          endDate
          geo
          data
          features
          version
          contentData
          content {
            _id
            name
            description
            subtitle
            type
            category
          }
          user {
            _id
            name
            profile {
              _id
              image
              name
            }
          }
        }
        pageInfo {
          total
          start
          perPage
        }
      }
    }
  }
`);
